import { render, staticRenderFns } from "./PurchaseDashboard.vue?vue&type=template&id=394689e6&lang=pug&"
import script from "./PurchaseDashboard.vue?vue&type=script&lang=ts&"
export * from "./PurchaseDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseDashboard.vue?vue&type=style&index=0&id=394689e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports